import Balancesheet from '@/components/Informations/Balancesheet/index.vue'
import Bsheet from '@/components/Informations/Bsheet/Bsheet.vue'
import Tradingaccount from '@/components/Informations/Tradingaccount/Tradingaccount.vue'
import PandL from '@/components/Informations/PandL/index.vue'
import Profitandloss from '@/components/Informations/Profitandloss/Profitandloss.vue'
import Prop from '@/components/Informations/Prop/index.vue'
import Proprietor from '@/components/Informations/Proprietor/Proprietor.vue'
import Itemsheet from '@/components/Informations/Itemsheet/index.vue'
import Interestsheet from '@/components/Informations/Interestsheet/index.vue'
import Alertsheet from '@/components/Informations/Alertsheet/index.vue'
import Defaultersheet from '@/components/Informations/Defaultersheet/index.vue'
import Unpickupsheet from '@/components/Informations/Unpickupsheet/index.vue'
import Firmsheet from '@/components/Informations/Firmsheet/index.vue'
import Bankstatement from '@/components/Informations/Bankstatement/index.vue'
import CashAccount from '@/components/Informations/CashAccount/CashAccounts.vue'
import GSTAccounts from '@/components/GSTReports/gstAccounts.vue'
import DiscountAccounts from '@/components/Discounts/DiscountAccounts'
import interestAccounts from '@/components/InterestAccount/InterestAccounts'
import TrailBalanceAccounts from '@/components/Informations/TrailBalanceAccount/TrailBalanceAccount.vue'
import CollectionBook from '@/components/Informations/CollectionBook/collectionBook.vue'
import HelpBook from '@/components/Informations/HelpBook/helpBook.vue'
import DeletedInvoiceBook from '@/components/Informations/DeletedInvoices/DeletedInvoice.vue';
import ExtraChargesInvoices from '@/components/Informations/ExtraCharges/ExtraChargesInvoices.vue';
import IncentiveInvoices from '@/components/Informations/IncentiveInvoices/IncentiveInvoices.vue';
import SMSBook from '@/components/Informations/SMSBook/SmsBook.vue';
import ProductGroupReports from '@/components/Informations/ProductReports/ProductGroupReports';
import ProductSetReports from '@/components/Informations/ProductReports/ProductSetReports';
import ProductTypeReports from '@/components/Informations/ProductReports/ProductTypeReports';
import ProductCategoryReports from '@/components/Informations/ProductReports/ProductCategoryReports';
import MultiPrintInvoices from '@/components/Informations/MultiPrintInvoices/MultiPrintInvoices.vue'
import ProductOrderReport from '@/components/Informations/ProductOrderReport/ProductOrderReport.vue';
import ProductLeadReport from '@/components/Informations/ProductLeadReport/ProductLeadReport.vue';
import ProductEstimateReport from '@/components/Informations/ProductEstimateReport/ProductEstimateReport.vue';
import BatchReport from '@/components/Informations/BatchReport/BatchReport.vue';

export default [{
  path: 'balancesheet',
  name: 'Balancesheet',
  component: Balancesheet,
  meta: {requiresAuth: true}
}, 
{
  path: 'bsheet',
  name: 'Bsheet',
  component: Bsheet,
  meta: {requiresAuth: true}
},
{
  path: 'tradingaccount',
  name: 'Tradingaccount',
  component: Tradingaccount,
  meta: {requiresAuth: true}
},
{
  path: 'pandl',
  name: 'PandL',
  component: PandL,
  meta: {requiresAuth: true}
},
{
  path: 'prop',
  name: 'Prop',
  component: Prop,
  meta: {requiresAuth: true}
},
{
  path: 'profitandloss',
  name: 'Profitandloss',
  component: Profitandloss,
  meta: {requiresAuth: true}
}, {
  path: 'proprietor',
  name: 'Proprietor',
  component: Proprietor,
  meta: {requiresAuth: true}
}, {
  path: 'itemsheet',
  name: 'Itemsheet',
  component: Itemsheet,
  meta: {requiresAuth: true}
}, {
  path: 'interestsheet',
  name: 'Interestsheet',
  component: Interestsheet,
  meta: {requiresAuth: true}
}, {
  path: 'alertsheet',
  name: 'Alertsheet',
  component: Alertsheet,
  meta: {requiresAuth: true}
}, {
  path: 'defaultersheet',
  name: 'Defaultersheet',
  component: Defaultersheet,
  meta: {requiresAuth: true}
}, {
  path: 'unpickupsheet',
  name: 'Unpickupsheet',
  component: Unpickupsheet,
  meta: {requiresAuth: true}
}, {
  path: 'firmsheet',
  name: 'Firmsheet',
  component: Firmsheet,
  meta: {requiresAuth: true}
}, {
  path: 'bankstatement',
  name: 'Bankstatement',
  component: Bankstatement,
  meta: {requiresAuth: true}
}, {
  path: 'cashaccount',
  name: 'CashAccount',
  component: CashAccount,
  meta: {requiresAuth: true}
}, {
  path: 'gst-accounts',
  name: 'GSTAccounts',
  component: GSTAccounts,
  meta: {requiresAuth: true}
}, {
  path: '/discount-accounts',
  name: 'DiscountAccounts',
  component: DiscountAccounts,
  meta: {requiresAuth: true}
},{
  path: 'trail-balance-accounts',
  name: 'TrailBalanceAccounts',
  component: TrailBalanceAccounts,
  meta: {requiresAuth: true}
}, {
  path: 'interest-accounts',
  name: 'interestAccounts',
  component: interestAccounts,
  meta: {requiresAuth: true}
}, 
{
  path: 'collection-book',
  name: 'CollectionBook',
  component: CollectionBook,
  meta: {requiresAuth: true}
},
{
  path: 'help-book',
  name: 'HelpBook',
  component: HelpBook,
  meta: {requiresAuth: true}
},
{
    path: 'deleted-invoice-book',
    name: 'DeletedInvoiceBook',
    component: DeletedInvoiceBook,
    meta: {requiresAuth: true}
},
{
    path: 'extra-charges-book',
    name: 'ExtraChargesInvoices',
    component: ExtraChargesInvoices,
    meta: {requiresAuth: true}
}, 
{
    path: 'Incentive-book',
    name: 'IncentiveInvoices',
    component: IncentiveInvoices,
    meta: {requiresAuth: true}
},
{
  path: 'SMS-book',
  name: 'SMSBook',
  component: SMSBook,
  meta: {requiresAuth: true}
},
{
  path: 'Product-Group-Reports',
  name: 'ProductGroupReports',
  component: ProductGroupReports,
  meta: {requiresAuth: true}
},
{
  path: 'batch-report',
  name: 'BatchReport',
  component: BatchReport,
  meta: {requiresAuth: true}
},
{
  path: 'product-order-report',
  name: 'ProductOrderReport',
  component: ProductOrderReport,
  meta: {requiresAuth: true}
},
{
  path: 'product-lead-report',
  name: 'ProductLeadReport',
  component: ProductLeadReport,
  meta: {requiresAuth: true}
},
{
  path: 'product-estimate-report',
  name: 'ProductEstimateReport',
  component: ProductEstimateReport,
  meta: {requiresAuth: true}
},
{
  path: 'Product-Type-Reports',
  name: 'ProductTypeReports',
  component: ProductTypeReports,
  meta: {requiresAuth: true}
},
{
  path: 'Product-Category-Reports',
  name: 'ProductCategoryReports',
  component: ProductCategoryReports,
  meta: {requiresAuth: true}
},
{
  path: 'Product-Set-Reports',
  name: 'ProductSetReports',
  component: ProductSetReports,
  meta: {requiresAuth: true}
},
{
  path: 'multi-print-invoices',
  name : 'MultiPrintInvoices',
  component : MultiPrintInvoices,
  meta: {requiresAuth: true}
}
]



// WEBPACK FOOTER //
// ./src/router/home/informations/index.js